import { Component } from '@angular/core';
import { AppState } from '../../../../app/app.global';
import { HttpService } from '../../../../providers/service/httpservice';
import { SCORELIST,SSEMESTERLIST } from '../../../../providers/config/serviceurl';
import { StorageService } from '../../../../providers/service/storageservice';

@Component({
  selector: 'scorequery',
  templateUrl: 'scorequery.html'
})

export class ScoreQueryPage {
	
	yearList:any=[];
	semesterList:any=[];
	scoreList:any=[];
	semesters:any=[];
	selectSemeter:string;
	user:any;
	selectYear:string;
	constructor(public global: AppState,private httpService:HttpService) {
		 this.user = StorageService.getObj('currentUser');
		 this.yearList = StorageService.getObj('yearList');
		 this.scoreList = StorageService.getObj('sscoreList');
		 this.semesterList = StorageService.getObj('ssemesterList');
		 this.httpService.get(SSEMESTERLIST,{"hd":this.user.hd}).then(anyObj => this.handleSemesterData(anyObj));
	}
	
	handleSemesterData(obj:any){
		if(obj&&obj.length>0){
      this.semesters = obj;
      this.yearList = [];
      for(let i=0;i<obj.length;i++){
      	if(this.yearList.indexOf(obj[i].sYear) < 0){
      		this.yearList.push(obj[i].sYear);
      	}
      }
      StorageService.setObj("syearList",this.yearList);
      this.selectYear = this.semesters[0].sYear;
      this.semesterList = this.getSemesterByYear(this.semesters,this.selectYear);
      StorageService.setObj("ssemesterList",this.semesterList);
      this.selectSemeter = this.semesterList[0].value;
      this.httpService.get(SCORELIST,{"hd":this.user.hd,"sYear":this.selectYear,"semester":this.semesterList[0].value}).then(anyObj => this.handleScoreList(anyObj));
		}
	}
	handleScoreList(obj:any){
  	if(obj){
     this.scoreList = obj;
     StorageService.setObj("scoreList",this.scoreList);
		}
 }
	changeSemeter(selectYear,selectSemeter){
		this.httpService.get(SCORELIST,{"hd":this.user.hd,"sYear":selectYear,"semester":selectSemeter}).then(anyObj => this.handleScoreList(anyObj));
	}
	changeYear($event){
		 this.semesterList = this.getSemesterByYear(this.semesters,$event);
		 if(this.semesterList.length > 0){
		 	 this.selectSemeter=this.semesterList[0].value;
		   this.httpService.get(SCORELIST,{"hd":this.user.hd,"sYear":this.selectYear,"semester":this.semesterList[0].value}).then(anyObj => this.handleScoreList(anyObj));
		 }
		
	}
	
	getSemesterByYear(obj:any,year:string):any{
		let semesterArry = [];
		for(let i = 0; i < obj.length;i++){
			if(year == obj[i].sYear){
				let item = {};
				if(obj[i].semester == "1"){
					item = {"semester":"第一学期","value":"1"};
				}else if(obj[i].semester == "2"){
					item = {"semester":"第二学期","value":"2"};
				}
				semesterArry.push(item)
			}
    }
		return semesterArry;
	}
	loadMore(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 500);
  }
  //下拉刷新
  doRefresh(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }
}


// WEBPACK FOOTER //
// ./src/pages/application/teaching/score/scorequery.ts